<template>
	<div>
      <v-container grid-list-xl>         
        <v-flex lg12 class="userInfo">
          <div class="historyBox">            
            <table width="100%" cellspacing="10">
              <tr>
                <td><strong>TRADING AS:</strong></td>
                <td>{{ currentCompany.trading_name }}</td>
              </tr>              
              <tr>
                <td><strong>VAT NO:</strong></td></td>
                <td>{{ currentCompany.vat_no }}</td>
              </tr>
              <tr>
                <td><strong>REGISTRATION NO:</strong></td>
                <td>{{ currentCompany.registration_no }}</td>
              </tr>
              <tr>
                <td><strong>CONTACT NO:</strong></td>
                <td>{{ currentCompany.contact_no }}</td>
              </tr>
              <tr>
                <td><strong>FAX NO:</strong></td>
                <td>{{ currentCompany.fax_no }}</td>
              </tr>
              <tr>
                <td><strong>EMAIL ADDRESS:</strong></td>
                <td>{{ currentCompany.email }}</td>
              </tr>
              <tr>
                <td><strong>ADDRESS:</strong></td>
                <td v-html="fncCreateAddress()">{{ fncCreateAddress() }}</td>
              </tr>
              <tr>
                <td><strong>REGION:</strong></td>
                <td>{{ currentCompany.region }}</td>
              </tr>
            </table>
          </div>
        </v-flex>     
        <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
          <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>              
            </div>
          </div>
        </v-layout>
      </v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
              search: '',
              currentUserCompany: this.$store.getters.currentUserCompany,
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncCreateAddress() {
              var strAddress = '';
              if (this.currentCompany.delAddress != '' ) {
                strAddress += this.currentCompany.delAddress + '<br />';
              }              
              if (this.currentCompany.delPostalCode != '' && this.currentCompany.delPostalCode != null) {
                strAddress += this.currentCompany.delPostalCode + '<br />';
              }
              if ( strAddress == '' ) {
                strAddress = 'N/A';
              }
              return strAddress;
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'currentCompany'                
			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>